'use client';

import { Anchor } from '@/components/ui/anchor';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { useDataAnalytics } from '@/hooks/analytics/analytics';
import { Attribute } from '@cinemark/content-api-client';

type TheaterAmenityDialogProps = {
  attribute: Attribute;
  children: React.ReactNode;
  ctaLink?: string;
  ctaText?: string;
  dataLinkName: string;
};

export const TheaterAmenityDialog = ({ attribute, children, ctaLink, ctaText, dataLinkName }: TheaterAmenityDialogProps): React.JSX.Element => {
  const { trackClick } = useDataAnalytics();

  return (
    <Dialog>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>

      <DialogContent className="sm:w-[400px]">
        <DialogHeader>
          <DialogTitle data-test="dialog-theater-amenity-title">{attribute.displayName}</DialogTitle>
        </DialogHeader>

        <DialogDescription className="sr-only">Theater amenity description</DialogDescription>

        {attribute.description &&
          <p data-test="dialog-theater-amenity-description">
            {attribute.description}
          </p>
        }

        {ctaLink && ctaText &&
          <Anchor data-test="link-amenity-cta"
            href={ctaLink}
            onClick={() => trackClick({ linkCategory: 'Amenity Modal', linkName: dataLinkName })}
          >
            {ctaText}
          </Anchor>
        }
      </DialogContent>
    </Dialog>
  );
};
